export const disabledCheckboxStyles = {
  tooltipContainerStyle: { width: "240px" },
};

export const approvedPracticesStyles = {
  tooltipContainerStyle: { width: "248px" },
};
